module.exports = __webpack_public_path__ + "img/Middle-Vertical-Rectangular-Attachment-28.78e8c80e.png";